var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"stagger"},on:{"enter":_vm.enter,"leave":_vm.leave,"enter-cancelled":_vm.enterCancelled,"leave-cancelled":_vm.leaveCancelled,"after-leave":_vm.complete,"after-enter":_vm.complete}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2a8bedc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/transitions/TransitionStagger.vue
// module id = Wjv0
// module chunks = 0